import { Directive, Input, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[appInputFilter]',
})
export class InputFilterDirective implements OnInit {
  @Input() appInputFilter: string = 'alphanumeric';

  // Pattern to validate against
  private pattern!: RegExp;

  // Predefined patterns repository
  private readonly patterns: Record<string, RegExp> = {
    'alpha-dash': /^[a-zA-Z_-]$/,
    alpha: /^[a-zA-Z]$/,
    numeric: /^[0-9]$/,
    alphanumeric: /^[a-zA-Z0-9]$/,
    email: /^[a-zA-Z0-9@._-]$/,
    'alphanumeric-space': /^[a-zA-Z0-9\s_-]$/,
    hex: /^[0-9a-fA-F]$/,
    'url-safe': /^[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]$/,
  };

  ngOnInit(): void {
    this.setPattern(this.appInputFilter);
  }

  /**
   * Sets the pattern based on input string
   */
  private setPattern(patternName: string): void {
    // Check if it's a predefined pattern
    if (this.patterns[patternName]) {
      this.pattern = this.patterns[patternName];
      return;
    }
    // Check if it's a custom regex pattern (format: /pattern/)
    if (patternName && patternName.startsWith('/') && patternName.length > 2) {
      try {
        const lastSlashIndex = patternName.lastIndexOf('/');
        const regexStr = patternName.substring(1, lastSlashIndex);
        const flags = patternName.substring(lastSlashIndex + 1) || '';
        this.pattern = new RegExp(regexStr, flags);
        return;
      } catch (e) {
        console.warn(
          `Invalid regex pattern: ${patternName}. Falling back to alphanumeric.`
        );
      }
    }
    // Fallback to alphanumeric if no valid pattern
    this.pattern = this.patterns[`alphanumeric`];
  }

  /**
   * Input validator that runs on each keypress
   */
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): boolean {
    // Special keys like backspace, tab should be allowed
    if (!event.key || event.key.length !== 1) {
      return true;
    }
    // Test the character against the pattern
    if (!this.pattern.test(event.key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  /**
   * Updates pattern when the input binding changes
   */
  @Input() set appInputFilterPattern(value: string) {
    if (value) {
      this.setPattern(value);
    }
  }
}
